import React from "react";
import tv from "../../apple-responsive-replica-html-css-mar-2020/images/icons/apple-tv-logo.png";
import banker from "../../apple-responsive-replica-html-css-mar-2020/images/home/banker.png";
import watch from "../../apple-responsive-replica-html-css-mar-2020/images/icons/watch-series5-logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { faCirclePlay } from "@fortawesome/free-solid-svg-icons";

function Section_5() {
  return (
    <div>
      <section className="fifth-heghlight-wrapper">
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-wrapper col-sm-12 col-md-6">
              <div className="left-side-container">
                <div className="top-logo-wrapper">
                  <div className="logo-wrapper">
                    <img src={tv} />
                  </div>
                </div>

                <div className="tvshow-logo-wraper">
                  <img src={banker} />
                </div>

                <div className="watch-more-wrapper">
                  <a href="#">
                    <p>
                      Watch now on the Apple TV App {"  "}
                      <FontAwesomeIcon icon={faCirclePlay} />
                    </p>
                  </a>
                </div>
              </div>
            </div>
            <div className="right-side-wrapper col-sm-12 col-md-6">
              <div className="right-side-container">
                <div className="top-logo-wrapper">
                  <div className="logo-wrapper">
                    <img src={watch} />
                  </div>
                </div>
                <div className="description-wraper">
                  With the Always-On Retina display.
                  <br />
                  You’ve never seen a watch like this.
                </div>
                <div className="links-wrapper">
                  <ul>
                    <li>
                      <a href="">
                        Learn more <FontAwesomeIcon icon={faAngleRight} />
                      </a>
                    </li>
                    <li>
                      <a href="">
                        Buy <FontAwesomeIcon icon={faAngleRight} />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Section_5;
